export const SET_NOTIFICATION = "SET_NOTIFICATION@notification";
export const RESET_NOTIFICATION = "RESET_NOTIFICATION@notification";
